import Table from 'components/commons/table'
import ModalDelete from 'components/commons/modal-delete'
import {TABLE_BEAUTY_PROFILE} from "configs/general-settings/configTableBeautyProfileList";

export const BeautyProfileList = ({
    dataList,
    query,
    onChangeQuery,
    onDelete,
    showModalDelete,
    onShowModalDelete,
    onHideModalDelete,
    isDeleting,
    isLoading,
}) => {
    return (
        <div className={'px-9 py-4'}>
            <Table
                className={'my-3'}
                name={TABLE_BEAUTY_PROFILE.name}
                columns={TABLE_BEAUTY_PROFILE.column}
                data={dataList?.results}
                size={query?.limit}
                currentPage={query?.page}
                totalPage={dataList?.total_page}
                totalResult={dataList?.total_result}
                onChangePage={(val) => onChangeQuery({ page: val })}
                onClickItem={onShowModalDelete}
                loading={isLoading}
            />
            {showModalDelete && (
                <ModalDelete
                    show={showModalDelete}
                    onHide={onHideModalDelete}
                    description={'Are You Sure Delete This?'}
                    isLoading={isDeleting}
                    onDelete={onDelete}
                />
            )}
        </div>
    )
}
